module.exports = __webpack_public_path__ + "assets/images/icons/religio-00.svg?v=e1c70096";